/**
 * @generated SignedSource<<95d03718c33f8b17658befd05ca7e2ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoEditNewMainOrgTitleAndDescription_todo$data = {
  readonly body: string | null;
  readonly formattedBody: string | null;
  readonly title: string;
  readonly " $fragmentType": "TodoEditNewMainOrgTitleAndDescription_todo";
};
export type TodoEditNewMainOrgTitleAndDescription_todo$key = {
  readonly " $data"?: TodoEditNewMainOrgTitleAndDescription_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainOrgTitleAndDescription_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditNewMainOrgTitleAndDescription_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedBody",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "36fd4eecc6b3ac19f926dc889564510d";

export default node;
